import { SharedConfig } from "@fmc-digital/core-utils";

import { parseConfigBoolean, type RuntimeConfig } from "./auth.config";

/**
 * Mirrors runtime VWO settings into SharedConfig so @fmc-digital/core-utils helpers
 * (e.g. logging) stay aligned with the app. Call after `config.init(runtimeConfig)`.
 */
export function applyVwoSharedConfigFromRuntime(runtimeConfig: RuntimeConfig): void {
  const flat = runtimeConfig as RuntimeConfig & {
    environment?: string;
    __env?: string;
  };
  let envLabel = "unknown";
  if (typeof flat.environment === "string") {
    envLabel = flat.environment;
  } else if (typeof flat.__env === "string") {
    envLabel = flat.__env;
  }

  SharedConfig.set("ENVIRONMENT", envLabel);
  SharedConfig.set("isVWOEnabled", parseConfigBoolean(runtimeConfig.isVWOEnabled));
  SharedConfig.set("vwoAccountId", Number(runtimeConfig.vwoAccountId ?? 0));
  SharedConfig.set("vwoSDKKey", String(runtimeConfig.vwoSDKKey ?? ""));
  SharedConfig.set("vwoProxyUrl", String(runtimeConfig.vwoProxyUrl ?? ""));
  SharedConfig.set("vwoEnv", String(runtimeConfig.vwoEnv ?? ""));
}
